import { useMutation, useQueryClient } from '@tanstack/react-query';
import supabaseClient from './supabaseClient';

type UpdateUserCredentialsRequest = {
  email?: string;
  password?: string;
};

const useUpdateUserCredentials = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ email, password }: UpdateUserCredentialsRequest) => {
      const updateData: { email?: string; password?: string } = {};

      if (email) updateData.email = email;
      if (password) updateData.password = password;

      const { data, error } = await supabaseClient.auth.updateUser(updateData);

      if (error) {
        throw error;
      }

      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['currentUser'] });
    },
  });
};

export default useUpdateUserCredentials;
